import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LazyLoadModule } from 'src/core-lib/lazy-load/lazy-load.module';
import { LAZY_MODULE_COMPONENT_REFERENCE } from 'src/core-lib/lazy-load/tokens';
import { BlockListOutletComponent } from './components/block-list-outlet/block-list-outlet.component';
import { ElementOutletComponent } from './components/element-outlet/element-outlet.component';
import { GridOutletComponent } from './components/grid-outlet/grid-outlet.component';
import { GridProviders } from './tokens';



@NgModule({
  declarations: [GridOutletComponent, ElementOutletComponent, BlockListOutletComponent],
  imports: [
    CommonModule,
    LazyLoadModule
  ],
  exports: [GridOutletComponent, ElementOutletComponent, BlockListOutletComponent]
})
export class GridModule {
  static add(add: GridProviders): ModuleWithProviders<GridModule> {
    return {
      ngModule: GridModule,
      providers: [
        {
            provide: LAZY_MODULE_COMPONENT_REFERENCE,
            useValue:  add.elements,
            multi: true,
        },
        {
            provide: LAZY_MODULE_COMPONENT_REFERENCE,
            useValue:  add.rows,
            multi: true,
        }
      ]
    };
  }
}
